import axios from 'axios';
import { BASENAME } from '../constants/general';

let breadcrumbs = '';

let referrerSent = false;

export const setBreadcrumbForLocal = response => {
	breadcrumbs = response[0].label;
};

const getReferrer = () => {
	let referrer = document.referrer || null;

	if (referrer && referrer.includes(BASENAME)) {
		referrer = null;
	}

	if (referrerSent) {
		referrer = null;
	} else {
		referrerSent = true;
	}

	return referrer;
};

export const localLog = segment => {
	let obj = {
		prt_products_segment: segment
	};
	return recordEvent('PRT_FIND_PRODUCT', JSON.stringify(obj), null, null);
};

export const localDownloadLog = async trackingParameters => {
	let obj = {
		prt_products_segment: trackingParameters.segment,
		prt_datasheet_name: trackingParameters.partNumber,
		prt_datasheet_link: trackingParameters.redirectLink,
		prt_opn: trackingParameters.opn
	};

	return recordEvent('PRT_DOWNLOAD_SHEET', JSON.stringify(obj), trackingParameters.partRankIndex, null);
};

export const localProductLog = async trackingParameters => {
	let obj = {
		prt_products_segment: trackingParameters.segment,
		prt_product_name: trackingParameters.partNumber,
		prt_opn: trackingParameters.opn
	};
	return recordEvent('PRT_VIEW_WPN', JSON.stringify(obj), trackingParameters.partRankIndex, null);
};

export const localView = segment => {
	let obj = {
		page_title: 'PRT+ ' + segment,
		page_breadcrumbs: '/Design/Tools & Software/PRT+/' + breadcrumbs,
		page_section: 'Design',
		page_segment: 'Tools & Software'
	};

	return recordEvent('PRT_VIEW', JSON.stringify(obj), null, null);
};

export const localSnapMagicLog = ({ eventName, opn, currentPrt, element, partId }) => {
	const data = {
		prt_snapmagic_event: eventName,
		prt_snapmagic_opn: opn,
		prt_snapmagic_prt: currentPrt,
		prt_snapmagic_element: element,
		prt_snapmagic_part_id: partId
	};

	return recordEvent(eventName, JSON.stringify(data), null, opn);
};

export function recordEvent(name, data, partRankIndex, opn) {
	return axios
		.post(BASENAME + '/api/trackEvent', {
			name: name,
			data: data,
			partRankIndex: partRankIndex,
			opn: opn,
			referrer: getReferrer()
		})
		.catch(error => {
			console.error('recordEvent error', error);
		});
}
